import { ChartPie, KeyRound, MonitorSmartphone, SlidersHorizontal } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'
import { AGENT_PERMISSIONS } from '@/lib/permissions'

import { dataCollectionRoute } from './data-collection-route'
import { agentsDashboardRoute } from './routes'
import { entityAgentAddRoute } from './routes'
import { entityAgentConfigurationRoute } from './routes'
import { entityAgentNetworkDiscoveryRoute } from './routes'
import { entityAgentDetailRoute } from './routes'
import { entityAgentDiagnosticsRoute } from './routes'
import { entityAgentDiscoveryRoute } from './routes'
import { entityAgentCollectedDataRoute } from './routes'
import { entityAgentOperationDetailRoute } from './routes'
import { entityAgentSettingsRoute } from './routes'
import { entityAgentsRoute } from './routes'
import { entityAgentPsksRoute } from './routes'
import { agentHomeWidgets } from './features/agent-health/home-widgets'

const dataCollectionArea = defineArea({
  id: 'dataCollection',
  label: 'Data collection sections',
  product: 'data-collection',
  gated: true,
  route: dataCollectionRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    dataCollection: typeof dataCollectionArea
  }
}

export const agentsModule = defineModule({
  widgets: agentHomeWidgets,
  routes: [
    dataCollectionRoute,
    entityAgentsRoute,
    agentsDashboardRoute,
    entityAgentPsksRoute,
    entityAgentConfigurationRoute,
    entityAgentNetworkDiscoveryRoute,
    entityAgentAddRoute,
    entityAgentDetailRoute,
    entityAgentCollectedDataRoute,
    entityAgentDiagnosticsRoute,
    entityAgentDiscoveryRoute,
    entityAgentSettingsRoute,
    entityAgentOperationDetailRoute,
  ],
  products: [
    {
      id: 'data-collection',
      label: 'Data Collection',
      description: 'Agents, assets, and collection access',
      icon: MonitorSmartphone,
      order: 30,
      routes: [dataCollectionRoute],
    },
  ],
  areas: [dataCollectionArea],
  sections: {
    dataCollection: [{ id: 'agents', label: 'Agents', order: 10 }],
  },
  navigation: {
    dataCollection: [
      {
        to: '/$entityId/agents',
        label: 'Agents',
        icon: MonitorSmartphone,
        permission: AGENT_PERMISSIONS.read,
        section: 'agents',
        order: 10,
      },
      {
        to: '/$entityId/agents/overview',
        label: 'Overview',
        icon: ChartPie,
        permission: AGENT_PERMISSIONS.read,
        section: 'agents',
        order: 5,
      },
      {
        to: '/$entityId/agents/psks',
        label: 'Pre-shared keys',
        icon: KeyRound,
        permission: AGENT_PERMISSIONS.read,
        section: 'agents',
        order: 20,
      },
      {
        to: '/$entityId/assets/configuration',
        label: 'Configuration',
        icon: SlidersHorizontal,
        permission: AGENT_PERMISSIONS.read,
        section: 'assets',
        order: 20,
      },
    ],
  },
})
